import React, { createContext, useEffect } from "react";
import { Authv2 } from "./authv2";
import { tryLoginOptions } from "../../services/interfaces";
import { activityState } from "../../config/constants";
import Loader from "../loader";
import Loginv2 from "./login";
import { Store } from "react-notifications-component";
// import { getPermissions } from "../../services/api";
import { useDispatch, useSelector } from "react-redux";
// import { setPermissionStatus, setPermissions, setToken } from "../../toolkit/reducers/permissionSlice";
import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";
import jwtDecode from "jwt-decode";
import { getRoles, getUserSettings } from "../../services/api";
import { RootState, actionCreators, store } from "../../store";
import { useTheme } from "../../theme/themeContext";
import i18n from "../../i18n/i18n";
import { tokenType } from "./TokenType";
import { clearConfigCache } from "prettier";
import { getENVData, paths } from "../../config/environment";
// import PermissionChecker from "../../navigation/auth/PermissionChecker";
// import {AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse} from "axios";

interface AuthContextType {
  isAuthenticated: string;
  tokens: any;
  accessToken: string;
  refreshToken: string;
  timeOut: number;
  generatedTime: Number;
  signIn: (token: any, onSignInComplete: Function) => void;
  checkClient: (
    skipPermission: boolean,
    onCheckClientComplete: Function
  ) => void;
  signOut: (onSignOutComplete: Function) => void;
  syncCookie: (onSyncComplete: Function) => void;
  tryLogin: (options: tryLoginOptions, onLoginComplete: Function) => void;
}
export const AuthContext = createContext<AuthContextType>(null!);

export function AuthClient({ children }: { children: React.ReactNode }) {
  const dispatch = useDispatch();
  const { encodedToken } = useSelector((state: RootState) => state?.Auth);
  const { loggedUserRoles } = useSelector((state: any) => state.Auth);
  const [isAuthenticated, setIsAuthenticated] = React.useState<string>(
    activityState.LOADING
  );
  const [accessToken, setAccessToken] = React.useState<string>("");
  const [permissionStatus, setPermissionStatus] = React.useState<number>(0);
  const [tokens, setTokens] = React.useState<any>({});
  const [refreshToken, setRefreshToken] = React.useState<string>("");
  const [timeOut, setTimeOut] = React.useState<number>(300000);
  const [generatedTime, setGeneratedTime] = React.useState<Number>(10000);
  const currentAccount = window.localStorage.getItem("currentAccount");

  let tryLogin = async (
    options: tryLoginOptions,
    onSignInComplete: Function
  ) => {
    setIsAuthenticated(activityState.WAIT);
    return Authv2.tryLogin(options, async (status: boolean, result: any) => {
      console.log("resultttt", result);
      if (status) {
        console.log("resultresultresultresult", result);
        setTokens(result);
        const data: tokenType = jwtDecode(result.access_token);
        // Dispatch token to redux//
        dispatch(actionCreators?.SetAccessToken(data));
        dispatch(actionCreators?.SetEncodedToken(result?.access_token));
        //* add decoded token to localStorage to maintain old voifinity functionality
        // if(data?.account_type==="super_admin" &&)
        window.localStorage.setItem("currentAccount", JSON?.stringify(data));
        setAccessToken(result.access_token);
        setAxios(result.access_token);
        setRefreshToken(result.refresh_token);
        setGeneratedTime(new Date().getTime());
        // pass token as arg , Redux update taking too long
        await handlePermission(data);
        handleTokenCycle();
        setIsAuthenticated(Authv2.isAuthenticated);
        onSignInComplete(Authv2.isAuthenticated);
        // setTimeout(() => {
        //     setPermissionStatus(200)
        // }, 200);
      } else {
        setIsAuthenticated(Authv2.isAuthenticated);
        Store.addNotification({
          title: "Failed",
          message: result,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: false,
          },
        });
      }
    });
  };

  // const navigate = useNavigate();

  const { toggleTheme } = useTheme();

  const languages = [
    {
      name: "English",
      key: "en",
    },
    {
      name: "French",
      key: "fr",
    },
    {
      name: "Spanish",
      key: "sp",
    },
  ];

  // console.log("tokenss", token)
  const getTenantInfo = async (sub: tokenType) => {
    const envData = paths?.keycloak;
    console.log("envDatatatat", encodedToken);
    const uuid =
      sub?.account_type === "tenant" ? sub?.tenant_id : sub?.telco_id;
    const url = `https://${envData}/v1/getTenantInfo`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${encodedToken}`,
          "hoolva-app": "b92307c2-1a60-4d4b-b1fe-4d3ba57d1ca5",
          // Add your bearer token here
        },
        body: JSON.stringify({ uuid: uuid }), // Payload must be stringified for fetch
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Result of getTenantInfo is", result);
      dispatch(actionCreators?.SetAccountInfo(result));
      window.localStorage.setItem("tenantInfo", JSON.stringify(result));
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleUserPreferences = (accessToken: tokenType) => {
    let previousAccount;
    try {
      previousAccount = JSON.parse(currentAccount ?? "{}");
    } catch (e) {
      previousAccount = null;
    }

    console.log("accesstoken");
    if (accessToken?.sub) {
      getUserSettings(accessToken?.sub, { admin_id: previousAccount?.uuid })
        .then((result: any) => {
          if (result?.apps) {
            handleRolesAndPermissions(accessToken);
            dispatch(actionCreators.SetUserSettings(result));
            dispatch(actionCreators.SetAppsList(result?.apps));

            const currentlanguage = languages?.filter(
              (node) =>
                node?.name?.toLowerCase().trim() ===
                result?.language?.toLowerCase().trim()
            )[0];
            i18n.changeLanguage(currentlanguage?.key ?? languages[0]?.key);
            toggleTheme(result?.theme ?? "light", () => {});
          } else if (result?.status === 403) {
            setPermissionStatus(403);
          }
        })
        .catch((error) => {
          console.log("errorisss", error);
        });
    }
  };

  const handleRolesAndPermissions = (accessToken: tokenType) => {
    let account = "";

    // supertelco simulated account is present in if
    if (accessToken["account_type"] === "super_admin" && currentAccount) {
      let previousAccount;
      try {
        previousAccount = JSON.parse(currentAccount ?? "{}");
      } catch (e) {
        previousAccount = null;
      }
      account =
        previousAccount?.type ?? previousAccount?.account_type?.split("_")[0];
    } else {
      account =
        accessToken["account_type"] === "super_admin"
          ? "super"
          : accessToken["account_type"];
    }

    let payload = { name: `${account}_admin` };
    getRoles(payload).then((result: any) => {
      if (Array.isArray(result)) {
        console.log("loggedUserROles", result);
        dispatch(actionCreators.setUserRoles(result));
        setTimeout(() => {
          setPermissionStatus(200);
        }, 200);
      }
    });
  };

  // console.log("styate", store?.getState())

  const handlePermission = async (data: tokenType) => {
    //     setTimeout(async () => {
    //Below fn's handle UserRoles,Permissions & Theme/Language, you can view permissions inside loggedUserRoles in Redux //
    handleUserPreferences(data);

    getTenantInfo(data);
    //         // var flag = false;
    //         // Object.keys(data?.data).map((node: any) => {
    //         //     if (data?.data[node].length > 0) {
    //         //         flag = true
    //         //     }
    //         // })
    //         // // console.log("datadatadatadatadata",data)
    //         // if (!flag ) {
    //         //     dispatch(setPermissionStatus(403));
    //         //     navigate('portal/unautherized', { replace: true });
    //         // } else {
    //         //     dispatch(setPermissionStatus(data?.status));
    //         // }
    //     }, 100)
  };
  let signIn = (token: any, onSignInComplete: Function) => {
    return Authv2.signIn(token, () => {
      setIsAuthenticated(activityState.SUCCESS);
      onSignInComplete(Authv2.isAuthenticated);
    });
  };
  let checkClient = (
    skipPermission: boolean = false,
    onCheckClientComplete: Function
  ) => {
    setIsAuthenticated(activityState.SILENTCHECK);
    return Authv2.checkClient((result: any) => {
      if (result?.access_token) {
        setIsAuthenticated(Authv2.isAuthenticated);
        setTokens(Authv2.token);
        const data: tokenType = jwtDecode(result.access_token);
        // Dispatch token to redux//
        dispatch(actionCreators?.SetAccessToken(data));
        dispatch(actionCreators?.SetEncodedToken(result?.access_token));
        //* add decoded token to localStorage to maintain old voifinity functionality
        // below if condition checks for any account that is selected (telco/tenant) in supertelco simulation
        //  before the user refreshes the page and resumes browsing at the current page
        let previousAccount;
        try {
          previousAccount = JSON.parse(currentAccount ?? "{}");
        } catch (e) {
          previousAccount = null;
        }
        if (!(data?.account_type === "super_admin" && previousAccount)) {
          window.localStorage.setItem("currentAccount", JSON?.stringify(data));
        }
        setAxios(result.access_token);
        setAccessToken(result.access_token);
        setTimeOut((result.expires_in - 10) * 1000);
        setRefreshToken(result.refresh_token);
        setGeneratedTime(new Date().getTime());
        if (!skipPermission && Authv2.isAuthenticated) {
          handlePermission(data);
        } else {
          setTimeout(() => {
            setPermissionStatus(200);
          }, 200);
        }

        handleTokenCycle();
      } else {
        setIsAuthenticated(activityState.IDLE);
      }
      onCheckClientComplete(result.access_token);
    });
  };
  let syncCookie = (onCheckClientComplete: Function) => {
    return Authv2.syncCookie((result: any) => {
      setIsAuthenticated(Authv2.isAuthenticated);
      setTokens(Authv2.token);
      const data: tokenType = jwtDecode(result.access_token);
      // dispatch(setToken(data))
      dispatch(actionCreators?.SetAccessToken(data));
      dispatch(actionCreators?.SetEncodedToken(result?.access_token));
      //* add decoded token to localStorage to maintain old voifinity functionality
      window.localStorage.setItem("currentAccount", JSON?.stringify(data));
      setAccessToken(result.access_token);
      setAxios(result.access_token);
      setRefreshToken(result.refresh_token);
      onCheckClientComplete(Authv2.isAuthenticated);
    });
  };
  let signOut = (onSignOutComplete: Function) => {
    setIsAuthenticated(activityState.WAIT);
    return Authv2.signOut(refreshToken, () => {
      setTokens({});
      // dispatch(actionCreators?.SetAccessToken(data))
      // dispatch(actionCreators?.SetEncodedToken(result?.access_token))
      setIsAuthenticated(activityState.IDLE);
      // dispatch(setPermissionStatus(0));
      onSignOutComplete(Authv2.isAuthenticated);
      //* add decoded token to localStorage to maintain old voifinity functionality
      window.localStorage.removeItem("currentAccount");
      // dispatch(setToken({}))
      setAccessToken("");
      setRefreshToken("");
      setGeneratedTime(0);
    });
  };
  let value = {
    isAuthenticated,
    tokens,
    accessToken,
    refreshToken,
    timeOut,
    generatedTime,
    signIn,
    checkClient,
    signOut,
    syncCookie,
    tryLogin,
  };

  var timer: any;

  useEffect(() => {
    checkClient(false, () => {});
  }, []);
  // const onStorageUpdate = (event: StorageEvent) => {
  //     syncCookie(() => { })
  // }
  const handleTokenCycle = () => {
    if (
      isAuthenticated === activityState.SILENTCHECK ||
      isAuthenticated === activityState.SUCCESS
    ) {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        // delete axios.defaults.headers.common["x-auth-token"];
        checkClient(true, () => {});
      }, timeOut);
    }
  };
  // useEffect(() => {
  //     window.addEventListener("storage", onStorageUpdate);
  //     return () => {
  //         window.removeEventListener("storage", onStorageUpdate);
  //     };
  // }, []);
  const setAxios = (token: string) => {
    axios.defaults.headers.common["x-auth-token"] = "" + token;
    // axios.defaults.headers.put["Authorization"] = "Bearer " + token;
    // axios.defaults.headers.delete["Authorization"] = "Bearer " + token;
    // axios.defaults.headers.get["Authorization"] = "Bearer " + token;
  };
  useEffect(() => {
    console.log("isAuthenticated", isAuthenticated);
    if (
      isAuthenticated === activityState.SUCCESS ||
      isAuthenticated === activityState.SILENTCHECK
    ) {
    } else {
      axios.interceptors.request.clear();
      axios.interceptors.response.clear();
    }
  }, [isAuthenticated]);

  return (
    <AuthContext.Provider value={value}>
      {/* {permissionStatus}- {isAuthenticated} */}
      {/* {} */}
      {/* <iframe src="http://localhost:3000/ncs" style={{ display: "none" }} id="shared"></iframe> */}
      {permissionStatus === 200 &&
      (isAuthenticated === activityState.SUCCESS ||
        isAuthenticated === activityState.SILENTCHECK) ? (
        children
      ) : isAuthenticated === activityState.LOADING ||
        (permissionStatus === 0 &&
          (isAuthenticated === activityState.SUCCESS ||
            isAuthenticated === activityState.SILENTCHECK)) ? (
        <div className="h-screen w-screen flex justify-center items-center ">
          <Loader />
        </div>
      ) : permissionStatus === 403 ? (
        <div className="flex justify-center items-center w-screen h-screen ">
          <div className="max-w-md  text-center m-auto">
            <p className="text-2xl md:text-3xl font-light  leading-normal">
              {" "}
              Access Denied
            </p>
            <p className="mb-4 mt-2">
              {" "}
              You do not have the necessary permissions to view this page.
            </p>
            <p className="text-base">
              If you believe this is an error or you need access, please contact
              your administrator.
            </p>
          </div>
        </div>
      ) : (
        <Loginv2 />
      )}
    </AuthContext.Provider>
  );
}
export function useAuth() {
  return React.useContext(AuthContext);
}
